import React from 'react';
import { List, Button, Typography } from 'components';
import { CloseIconLight } from 'components/common/icons';
import styles from '../../styles.module.scss';

interface BrandsListProps {
  brands: Array<{ value: string; label: string }>;
  onDelete: (index: number) => void;
}

export const BrandsList: React.FC<BrandsListProps> = ({ brands, onDelete }) => {
  if (brands.length === 0) return null;

  return (
    <List
      dataSource={brands}
      style={{ marginBottom: 24 }}
      renderItem={(item, index) => (
        <List.Item
          className={styles.list_item}
          actions={[
            <Button
              key={'add'}
              size={'small'}
              type={'link'}
              icon={<CloseIconLight />}
              onClick={() => onDelete(index)}
            />,
          ]}
        >
          <Typography.Text
            ellipsis={{ tooltip: true }}
            style={{ maxWidth: 400, height: 32, marginTop: 8, marginLeft: 12 }}
          >
            {item.label}
          </Typography.Text>
        </List.Item>
      )}
    />
  );
};
